// Automatically detect API base URL based on environment
const getApiBaseUrl = (): string => {
  // In development, use the PHP dev server
  if (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    return "http://localhost:8000";
  }

  // In production, use relative paths (same domain)
  return "";
};

export const API_BASE_URL = getApiBaseUrl();

// Helper function to build API URLs
export const getApiUrl = (endpoint: string): string => {
  return `${API_BASE_URL}${endpoint}`;
};
